import throttle from 'lodash/throttle';

import AgentPresence from 'src/models/AgentPresence';
import agentPresenceResource from 'src/actions/agent/agentPresenceResource';

const PRESENCE_INTERVAL_MS = 1 * 60 * 1000;

export const configureAgentActivity = ({ dispatch }) => {
  const handleActivity = () => dispatch(agentPresenceResource.effects.set(new AgentPresence()));

  const throttled = throttle(handleActivity, PRESENCE_INTERVAL_MS);

  onActivity(throttled);
};

function onActivity(callback) {
  ['mousemove', 'wheel', 'keydown', 'click', 'focus'].forEach(name => {
    document.addEventListener(name, callback, { passive: true });
  });
}
